import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  dropdownOption: {
    padding: '1.6rem 1rem',
    '& button': {
      paddingLeft: 0,
    },
  },
  closeDealOption: {
    '&:hover': {
      backgroundColor: colors.green[100],
    },
    '&:active': {
      backgroundColor: colors.green[600],
      '& button': {
        color: colors.neutral.black,
      },
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
